import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { FuseConfigService } from '@fuse/services/config';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-terms-condition',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule],
  templateUrl: './terms-condition.component.html',
  styleUrl: './terms-condition.component.scss'
})
export class TermsConditionComponent {
  site= 'info@bizzsecure.com'
  private unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private fuseConfigService: FuseConfigService,
  ) {

    this.unsubscribeAll = new Subject();
    
    // Configure the layout
    this.fuseConfigService.config={
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnDestroy(): void {
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }
}
